import React from "react"
import { Helmet } from "react-helmet-async"
import { motion } from "framer-motion"
import { Navigation } from "@/components/Navigation"
import { HeroSection } from "@/components/HeroSection"
import { PartnerLogosSection } from "@/components/PartnerLogosSection"
import { AboutSection } from "@/components/AboutSection"
import { PromiseSection } from "@/components/PromiseSection"
import { WhyChooseSection } from "@/components/WhyChooseSection"
import { StatsSection } from "@/components/StatsSection"
import { HowItWorksSection } from "@/components/HowItWorksSection"
import { PartnerSection } from "@/components/PartnerSection"
import { TrustSection } from "@/components/TrustSection"
import { TestimonialsSection } from "@/components/TestimonialsSection"
import { CTASection } from "@/components/CTASection"
import { Footer } from "@/components/Footer"
import { SEO } from "@/components/SEO"

const Index = () => {
  return (
    <div className="min-h-dvh bg-background scroll-smooth">
      <SEO title="GrandPad Enterprise Edition" applySuffix={false}
           description="GrandPad is the simple, safe, and secure tablet that keeps seniors connected—helping healthcare organizations improve engagement and health outcomes."
           image="/images/og-home.jpg" />
      <Helmet>
        <link
          rel="preload"
          href="/images/hero-image-v2.webp"
          as="image"
          imageSrcSet="/images/hero-image-mobile.webp 824w, /images/hero-image-v2.webp 1382w"
          imageSizes="(max-width: 1023px) 100vw, 45vw"
          fetchPriority="high"
        />
      </Helmet>
      <Navigation />
      <main id="main-content">
        <section id="hero"><HeroSection /></section>
        <motion.div 
          className="w-full bg-seaglass py-6 max-lg:py-5 overflow-hidden"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.4 }}
        >
          <div className="flex justify-center items-center gap-2 text-h4 text-anchor font-bold max-lg:flex-col max-lg:gap-1 max-lg:text-h5">
            {["Simple by Design.", "Trusted Engagement.", "Proven Outcomes."].map((phrase, index) => (
              <motion.span
                key={phrase}
                initial={{ opacity: 0, y: 20, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ 
                  duration: 0.5, 
                  delay: 0.2 + index * 0.15,
                  ease: [0.22, 1, 0.36, 1]
                }}
              >
                {phrase}
              </motion.span>
            ))}
          </div>
        </motion.div>
        <PartnerLogosSection />
        <section id="about"><AboutSection /></section>
        <section id="promise"><PromiseSection /></section>
        <section id="why-choose"><WhyChooseSection /></section>
        <section id="stats"><StatsSection /></section>
        <section id="how-it-works"><HowItWorksSection /></section>
        <section id="partner"><PartnerSection /></section>
        <section id="trust"><TrustSection /></section>
        <section id="testimonials"><TestimonialsSection /></section>
        <section id="cta"><CTASection /></section>
      </main>
      <Footer />
    </div>
  )
}

export default Index
